import { readPageData } from '@ts/Util/page';
import { readCookie } from '@ts/Util/cookies';
import Swivel from 'swiveljs';
let swivel = null;
export const initSwivel = () => {
    if (swivel !== null) {
        return;
    }
    swivel = new Swivel({
        map: readPageData('swivelMap'),
        bucketIndex: readCookie('Swivel_Bucket'),
    });
};
export function swivelReturnValue(slug, onValue, offValue) {
    initSwivel();
    return swivel.returnValue(slug, onValue, offValue);
}
export const isSwivelOn = (slug) => {
    return swivelReturnValue(slug, true, false);
};
